import request from '../utils/requests'

export default {
  // 子模块文章信息

  // 子模块管理
  getChild (params) {
    return request({
      url: '/user/child/list',
      method: 'get',
      params
    })
  },
  // 相关链接管理
  getRealLink (params) {
    return request({
      url: '/user/connection/list',
      method: 'get',
      params
    })
  },

}



// WEBPACK FOOTER //
// ./src/api/child.js